import { render, staticRenderFns } from "./jtbianji.vue?vue&type=template&id=3af85b38&scoped=true"
import script from "./jtbianji.vue?vue&type=script&lang=js"
export * from "./jtbianji.vue?vue&type=script&lang=js"
import style0 from "./jtbianji.vue?vue&type=style&index=0&id=3af85b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af85b38",
  null
  
)

export default component.exports